import React from 'react';
import './Experience.css';
import iithLogo from '../assets/images/iithlogo.png';

const Experience = () => {
  const experiences = [
    {
      icon: 'fa-robot',
      title: 'Software Developer AI Intern',
      company: 'Single Point Solutions Pvt. Ltd.',
      location: 'Hyderabad, India',
      period: 'May 2025 - Jul 2025',
      description: 'Developed a procurement data analytics chatbot using Python, Mistral LLM, and MongoDB to automate data queries. Integrated the chatbot with internal systems for real-time data processing, utilizing NLP for improved response accuracy.'
    },
    {
      logo: iithLogo,
      icon: 'fa-flask',
      title: 'Research Intern',
      company: 'Indian Institute of Technology Hyderabad',
      location: 'Hyderabad, India',
      period: 'May 2024 - Jul 2024',
      description: 'Selected for research under Dr. N. R. Aravind to explore complex topics in theoretical computer science. Analyzed literature on NP-hard problems and graph algorithms; contributed insights to research discussions.'
    }
  ];

  return (
    <section id="experience" className="experience">
      <div className="container">
        <h1 className="section-title">Experience</h1>
        <div className="experience-grid">
          {experiences.map((exp, index) => (
            <div key={index} className="experience-card">
              {exp.logo ? (
                <img src={exp.logo} alt={exp.title} />
              ) : (
                <div className="experience-icon">
                  <i className={`fas ${exp.icon}`}></i>
                </div>
              )}
              <h2>{exp.title}</h2>
              <h3>{exp.company}</h3>
              <p className="location">{exp.location}</p>
              <p className="period">{exp.period}</p>
              <p>{exp.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
